import { getCookie } from './cookieHelper';

export const isIwocaDE = () => {
  const host = window.location.host;
  return (host && host.indexOf('.de') !== -1) || getCookie('locale') === 'de';
};
